import axios from 'axios';
import {axiosConfig as config} from 'config/axiosConfig';

const {REACT_APP_API} = process.env;
const baseUrl = `${REACT_APP_API}/servicios-hogar-planes`;



export const getAll = async ({page = '', limit = '', category = '', plan = '', unitPrice = '', comboPrice = ''}) => {
 const {data} = await axios.get(`${baseUrl}/?page=${page}&limit=${limit}&category=${category}&plan=${plan}&unitPrice=${unitPrice}&comboPrice=${comboPrice}`, config)
 return data
}

export const create = async ({hogarPlan = {}}) => {
 const {data} = await axios.post(baseUrl, hogarPlan, config)
 return data
}

export const update = async ({hogarPlan = {}, id}) => {
 const {data} = await axios.put(`${baseUrl}/${id}`, hogarPlan, config)
 return data
}

export const del = async ({id}) => {
 const {data} = await axios.delete(`${baseUrl}/${id}`, config)
 return data
}